import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
